import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { colors } from "src/styles/theme";
import { FullWidthButton } from "src/components";
import { ClubType, SelectedClubType } from "src/types";
import ImgZoomContainer from "../ImgZoomContainer";
import { useAlert, useRemoveSearchParams } from "src/hooks";
import notiOffImage from "src/assets/images/noti-off.png";

export default function AnnouncementAgreePopupContents(props: {
  preference: number;
  announcementShowingClub?: ClubType;
  setSelectedClubs: React.Dispatch<React.SetStateAction<SelectedClubType[] | undefined>>;
  closeParent?: () => void;
  closeMe?: () => void;
}) {
  const alert = useAlert();
  const [isAnnouncementChecked, setIsAnnouncementChecked] = useState(false);
  const [imageLoadError, setImageLoadError] = useState(false);
  const clubPreference = props.preference;

  const _removesome = useRemoveSearchParams(["announcement", "clubSearch"]);
  // const navigate = useNavigate();

  // 이미지 URL이 변경될 때마다 이미지 로드 상태 초기화
  useEffect(() => {
    setImageLoadError(false);
  }, [props.announcementShowingClub?.recruitment_notice_img_url]);

  console.log("이미지", props.announcementShowingClub?.recruitment_notice_img_url);
  const handleClickSelectSubmit = () => {
    let isDup = false;
    props.setSelectedClubs((clubs) => {
      if (clubs?.some((c) => c.id === props?.announcementShowingClub?.id)) {
        isDup = true;
        return [...clubs];
      }
      const filtered = clubs?.filter((c) => +c.preference !== clubPreference);

      return [
        ...(filtered ?? []),
        { preference: clubPreference, ...(props.announcementShowingClub as any) },
      ];
    });
    if (isDup) {
      alert({ title: "골프장 중복", content: "선택하신 골프장은 이미 등록되었습니다." });
    }
    // removesome();
    // props.closeMe && props.closeMe();
    // props.closeParent && props.closeParent();
    props.closeMe && props.closeMe();
    setTimeout(() => {
      props.closeParent && props.closeParent();
    }, 0);
  };
  return (
    <>
      <Container className=" d-flex fd-c gap-2 pd-2">
        <div className="">
          {props.announcementShowingClub?.recruitment_notice_img_url && !imageLoadError ? (
            <ImgZoomContainer
              imgUrl={props.announcementShowingClub.recruitment_notice_img_url}
              onError={() => setImageLoadError(true)}
            />
          ) : (
            <NoImageContainer>
              <img src={notiOffImage} alt="모집공고 없음" />
            </NoImageContainer>
          )}
        </div>
        <div className="check-line">
          <input
            type="checkbox"
            checked={isAnnouncementChecked}
            onChange={(e) => {
              setIsAnnouncementChecked(e.target.checked);
            }}
          />
          <p>
            {props?.announcementShowingClub?.name} 골프장의 연간 단체팀 이용 수칙을 이해하였고 이에
            동의합니다
          </p>
        </div>
        <FullWidthButton
          $colorTheme="green"
          disabled={!isAnnouncementChecked}
          onClick={() => {
            handleClickSelectSubmit();
          }}
        >
          골프장선택 확인
        </FullWidthButton>
      </Container>
    </>
  );
}

const Container = styled.div`
  overflow-x: hidden;
  .name-line {
    display: flex;
    align-items: flex-end;
    gap: 5px;
    > div {
      &:nth-of-type(1) {
      }
      &:nth-of-type(2) {
        font-size: 14px;
        color: ${colors.gray.first};
      }
    }
  }
  .req-img {
    width: 100%;
  }
  .check-line {
    input[type="checkbox"] {
      width: 30px;
    }
    display: flex;
    gap: 5px;
    font-size: 14px;
  }
`;

const NoImageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  background: #f5f5f5;
  border-radius: 8px;

  img {
    max-width: 600px;
    max-height: 600px;
    opacity: 0.6;
  }
`;
